<!-- to-do remove -->
<template>
  <div class="fts-result-not-found" v-if="show">
    <slot name="illustration" v-if="illustration">
      <img :src="illustrationSrc" class="illustration">
    </slot>
    <div class="not-found-container">
      <slot name="title" :title="getTitle">
        <div class="not-found-title">{{getTitle}}</div>
      </slot>    
      <slot name="content" :content="getContent">
        <div class="not-found-content">{{getContent}}</div>
      </slot>
      <slot name="createNew" v-if="!search && !error && creatable">
        <fts-btn text color="primary" class="fts-capitalize fts-font-normal new-action" @click="create">
          <font-awesome-icon :icon="['fas', 'plus']" fixed-width />Create new
        </fts-btn>
      </slot>
    </div>
  </div>  
</template>

<script>
import FTSBtn from "../FTSBtn";

/* assets */
import pageError from "../../../assets/images/client/pageError.png";
import nothingFound from "../../../assets/images/client/nothingFound.svg";
import createNew from "../../../assets/images/client/createNew.svg";

export default {
  props: {
    show: Boolean,
    title: String,
    content: String,
    illustration: {
      type: Boolean,
      default: true
    },
    search: Boolean,
    error: Boolean,
    creatable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    "fts-btn": FTSBtn
  },
  methods: {
    create() {
      this.$emit('create')
    },
  },
  computed: {
    illustrationSrc() {
      return this.error ? pageError : this.search ? nothingFound : createNew
    },
    getTitle() {
      return this.title ? this.title : this.error ? 'Error' : 'No results'
    },
    getContent() {
      if (this.content) 
        return this.content
      else if (this.error) 
        return 'Something went wrong. Please try again later.'
      else if (this.search) 
        return 'Try using different keywords or adjusting your filters.'
      else 
        return 'Looks a little bit empty here.'
    }
  }
}
</script>

<style lang="scss" scoped>
@use "./src/assets/scss/vars" as *;

.fts-result-not-found {
  @include flex-center-middle;
  flex-direction: column;
  max-width: 600px;
  margin: 0 auto;
  padding: 1rem;
  .illustration {
    margin-bottom: 2rem;
    width: 100%;
  }
  .not-found-container {
    text-align: center;
    .not-found-title {
      margin-bottom: 1rem;
      font-size: 1.5rem;
      font-weight: 500;
    } 
    .not-found-content {
      font-size: 1rem;
      color: var(--fts-gray-400);
    }
    .new-action {
      margin-top: 1rem;
    }
  }
}
</style>